// @flow

import urlUtil from 'app/common/lib/urlUtil';
import { type Pin } from 'app/common/react/components/PinRep/types';

export function stripWwwPrefix(url: string): string {
  return url.replace('www.', '');
}

export function getCarouselDomain(
  carouselData: ?$PropertyType<Pin, 'carousel_data'>,
  index?: number,
): string {
  const carouselIndex = index || (carouselData && carouselData.index) || 0;
  const carouselSlots = (carouselData && carouselData.carousel_slots) || [];
  const link = (carouselSlots[carouselIndex] && carouselSlots[carouselIndex].link) || '';
  return (link && urlUtil.parse(link).hostname) || '';
}

export default function getPinRepDomain(pin: Pin, carouselIndex?: number): string {
  const { carousel_data: carouselData, domain } = pin;

  let output = domain || '';

  // carouselData with an `id` is a true carousel pin. Otherwise, it's a
  // product carousel pin, and we'll just use the single domain for it.
  if (carouselData && carouselData.id) {
    output = getCarouselDomain(carouselData, carouselIndex);
  }

  return stripWwwPrefix(output);
}
